/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursesCourseidPlans200,
  GetApiV1CoursefinancialCoursesCourseidPlans400,
  GetApiV1CoursefinancialCoursesCourseidPlans401,
  GetApiV1CoursefinancialCoursesCourseidPlans404,
  GetApiV1CoursefinancialCoursesCourseidPlans500,
  GetApiV1CoursefinancialCoursesCourseidPlansPathParams,
  GetApiV1CoursefinancialCoursesCourseidPlansQueryParams,
  GetApiV1CoursefinancialCoursesCourseidPlansQueryResponse,
} from "../../types/courseFinancialRegistrationController/GetApiV1CoursefinancialCoursesCourseidPlans.ts";
import { courseFinancialListItemViewModelPaginatedResponseSchema } from "../courseFinancialListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CoursefinancialCoursesCourseidPlansPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansPathParams>;

export const getApiV1CoursefinancialCoursesCourseidPlansQueryParamsSchema =
  z.object({
    Search: z.optional(
      z
        .string()
        .describe("Texto livre aplicado à descrição do plano. Opcional."),
    ),
    Active: z.optional(
      z
        .boolean()
        .describe(
          "Filtra por situação do plano. Quando omitido, retorna ativos e inativos. No legado esse filtro era aplicado apenas no grid.",
        ),
    ),
    PageNumber: z.coerce
      .number()
      .int()
      .default(1)
      .describe("Página da listagem. Mínimo 1."),
    PageSize: z.coerce
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursesCourseidPlans200Schema = z.lazy(
  () => courseFinancialListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlans200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CoursefinancialCoursesCourseidPlans400Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlans400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursesCourseidPlans401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlans401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursesCourseidPlans404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlans404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursesCourseidPlans500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlans500>;

export const getApiV1CoursefinancialCoursesCourseidPlansQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursesCourseidPlans200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansQueryResponse>;
